import { Card, CardHeader, CardContent } from '@mui/material'
import PageContainer from '../layout/PageContainer'
import StoreKeyProvider from '../../providers/StoreKeyProvider'
import WithFilters from '../../hocs/WithFilters'
import DataTable from '../dataTable/DataTable'
import DataInputs from '../dataTable/DataInputs'
import PropTypes from 'prop-types'
// import NoContent from './NoContent'

const PatientsData = ({ doctorId }) => {
  return doctorId ? (
    <>
      <PageContainer>
        <StoreKeyProvider storeKey="PatientsDataKey">
          <WithFilters
            config={{
              page: 1,
              paginate: 10,
              orderType: 'desc',
              order: 'created_at',
              inputs: {
                examination_name: {
                  value: '',
                  relation: 'LIKE',
                },
                patient_name: {
                  values: '',
                  relation: 'LIKE',
                },
                min_created_at: {
                  value: null,
                  relation: 'MIN',
                },
                max_created_at: {
                  value: null,
                  relation: 'MAX',
                },
              },
            }}
            endpoint={`/doctors/${doctorId}/examinations`}
          >
            <Card elevation={2} square>
              <CardHeader title="Wyniki badań"></CardHeader>
              <CardContent>
                <DataInputs
                  inputs={[
                    {
                      id: 'examination_name',
                      label: 'Badanie',
                      placeholder: '',
                      type: 'text',
                    },
                    {
                      id: 'created_at',
                      label: 'Data wykonania',
                      placeholder: '',
                      type: 'date-between',
                    },
                    {
                      id: 'patient_name',
                      label: 'Imię/Nazwisko pacjenta',
                      placeholder: '',
                      type: 'text',
                    },
                  ]}
                />
                <DataTable
                  breakpoint={768}
                  actions="PatientsPreviewActions"
                  labels={[
                    'Badanie',
                    'Data utworzenia',
                    'Imię/Nazwisko pacjenta',
                  ]}
                  keys={['examination_name', 'created_at', 'patient_name']}
                />
              </CardContent>
            </Card>
          </WithFilters>
        </StoreKeyProvider>
      </PageContainer>
    </>
  ) : (
    <></>
  )
}

PatientsData.propTypes = {
  doctorId: PropTypes.number,
}

export default PatientsData
